<template>
  <div class="saved-filter-item">
    <div class="saved-filter-item__title">
      <BasicButton
        :href="filter.href"
        appearance="text"
        @click.native="$emit('click', $event)"
      >
        {{title}}
      </BasicButton>
    </div>
    <TrashButton @click="$emit('remove')" />
  </div>
</template>

<script>
  import BasicButton from "src/components/BasicButton/BasicButton.vue";
  import TrashButton from "src/components/buttons/TrashButton/TrashButton.vue";

  export default {
    name: 'SavedFilterItem',
    components: { TrashButton, BasicButton },
    props: {
      filter: {
        type: Object,
        required: true,
      }
    },
    computed: {
      title() {
        return this.filter.title.replace(/•/g, '+');
      }
    }
  }
</script>